import s from './LevelRing.module.css';

const SIZE = 102;
const STROKE = 11;
const RADIUS = (SIZE - STROKE) / 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

/**
 * Donut ring with a number in the centre. SVG-based so it is fully
 * background-agnostic — the inner area is genuinely transparent, no
 * radial-gradient cutout that fights with the host element's bg.
 *
 * progressPct is clamped to 0–100. The arc starts at 12 o'clock and sweeps
 * clockwise.
 */
export default function LevelRing({ level, progressPct = 0 }) {
  const pct = Math.max(0, Math.min(100, Number(progressPct) || 0));
  const dash = (pct / 100) * CIRCUMFERENCE;

  return (
    <div className={s.wrap}>
      <svg
        className={s.svg}
        width={SIZE}
        height={SIZE}
        viewBox={`0 0 ${SIZE} ${SIZE}`}
        aria-hidden="true"
      >
        <circle
          cx={SIZE / 2}
          cy={SIZE / 2}
          r={RADIUS}
          fill="none"
          stroke="rgba(255, 104, 33, 0.18)"
          strokeWidth={STROKE}
        />
        <circle
          cx={SIZE / 2}
          cy={SIZE / 2}
          r={RADIUS}
          fill="none"
          stroke="var(--color-brand-orange)"
          strokeWidth={STROKE}
          strokeLinecap="round"
          strokeDasharray={`${dash} ${CIRCUMFERENCE}`}
          transform={`rotate(-90 ${SIZE / 2} ${SIZE / 2})`}
        />
      </svg>
      <span className={s.level}>{Math.max(1, Number(level) || 0)}</span>
    </div>
  );
}
